import { upsertBulkCategories } from 'actions';
import LoadingIndicator from 'components/LoadingIndicator';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getUserCustomer } from 'selectors/auth';
import { getSelectedUseCaseOutcomes, getUpsertBulkCategoriesLoading } from 'selectors/bulkOutcomes';

const BulkOutcomesHeader: React.VFC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const loading = useSelector(getUpsertBulkCategoriesLoading);
  const customer = useSelector(getUserCustomer);
  const useCase = useSelector(getSelectedUseCaseOutcomes);

  const handleCancel = (): void => {
    history.goBack();
  };

  const handleSave = (): void => {
    dispatch(upsertBulkCategories());
  };

  return (
    <header
      className="bg-white w-full flex flex-row justify-between px-6 pt-6 pb-4"
      style={{
        filter: 'drop-shadow(5px 6px 18px rgba(0, 0, 0, 0.10))',
      }}
    >
      <div className="flex flex-col gap-3">
        <div>
          <button
            type="button"
            className="flex underline focus:outline-none"
            onClick={handleCancel}
          >
            {'< Back'}
          </button>
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-heading-2">Outcomes Manager</h2>
          <span className="text-subtitle">
            {customer?.name} : {useCase?.name}
          </span>
        </div>
      </div>
      <div className="flex flex-row gap-2 h-8 self-end">
        <button
          type="button"
          className="button button--secondary w-30 font-bold justify-center"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="button button--primary w-30 font-bold justify-center"
          onClick={handleSave}
        >
          {loading ? <LoadingIndicator size="5" /> : 'Save'}
        </button>
      </div>
    </header>
  );
};

export default BulkOutcomesHeader;
